export const ClearIcon = () => {
  return (
    <svg
      data-testid="clear-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
    >
      <path
        d="M20.1695 1.33032C19.7301 0.890869 19.0164 0.890869 18.577 1.33032L14.077 5.83032L13.5215 5.27485C12.9871 4.74048 12.168 4.62798 11.507 4.9936L10.3645 5.62642L15.8734 11.1284L16.5063 9.98579C16.8719 9.32837 16.7559 8.50571 16.225 7.97134L15.6695 7.41587L20.1695 2.91587C20.609 2.47642 20.609 1.76274 20.1695 1.32329V1.33032ZM9.0918 6.33657L3.07656 9.67993C2.72148 9.87681 2.5 10.253 2.5 10.6608C2.5 10.9596 2.61953 11.2444 2.82695 11.4553L4.3457 12.9741C4.41953 13.0479 4.53203 13.076 4.63398 13.0409L6.46563 12.4292C6.68711 12.3553 6.89453 12.5663 6.8207 12.7842L6.20898 14.6159C6.17383 14.7178 6.20195 14.8268 6.27578 14.9042L10.048 18.6729C10.259 18.8838 10.5438 18.9999 10.8426 18.9999C11.2504 18.9999 11.6266 18.7784 11.8234 18.4233L15.1668 12.4081L9.0918 6.33657Z"
        fill="#FA545E"
      />
    </svg>
  );
};

export const VehicleIcon = () => {
  return (
    <svg
      data-testid="vehicle-icon"
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.15612 3.55273H9.05003V7.30273H4.99987L6.09237 4.33789C6.26487 3.86523 6.68534 3.55273 7.15612 3.55273ZM10.775 7.30273V3.55273H13.6932C14.0417 3.55273 14.3724 3.72461 14.5916 4.02148L17.0066 7.30273H10.775ZM19.9822 7.3418L16.3885 2.45898C15.7344 1.56836 14.7425 1.05273 13.6932 1.05273H7.15612C5.74378 1.05273 4.47518 1.98633 3.95409 3.4082L2.45909 7.47461C1.60378 7.8418 0 7.89484 0 9.47379V13.158C0 15.2633 1 15.4277 2.15003 15.4277H3.34674C3.61987 17.2012 5.0394 18.5527 6.75003 18.5527C8.46065 18.5527 9.88018 17.2012 10.1533 15.4277H14.8467C15.1199 17.2012 16.5394 18.5527 18.25 18.5527C19.9606 18.5527 21.3802 17.2012 21.6533 15.4277H22.85C23.4861 15.4277 24 14.8691 24 14.1777V12.3027C24 9.75586 22.2463 7.6543 19.9822 7.3418ZM16.6221 14.1777C16.6953 13.9424 16.8108 13.7253 16.9618 13.5389C17.1129 13.3525 17.2965 13.2006 17.5021 13.092C17.7076 12.9834 17.931 12.9203 18.1591 12.9063C18.3873 12.8924 18.6157 12.9278 18.8312 13.0106C19.0467 13.0934 19.2448 13.222 19.4142 13.3887C19.5836 13.5555 19.7208 13.7572 19.8178 13.9821C19.9149 14.2069 19.9699 14.4505 19.9796 14.6987C19.9893 14.9469 19.9535 15.1947 19.8744 15.4277C19.8012 15.663 19.6857 15.8802 19.5346 16.0666C19.3836 16.253 19.1999 16.4049 18.9944 16.5135C18.7888 16.622 18.5655 16.6852 18.3373 16.6991C18.1092 16.7131 17.8807 16.6776 17.6652 16.5948C17.4498 16.512 17.2516 16.3835 17.0822 16.2168C16.9129 16.05 16.7757 15.8483 16.6786 15.6234C16.5815 15.3985 16.5266 15.1549 16.5169 14.9067C16.5072 14.6586 16.5429 14.4108 16.6221 14.1777ZM6.75003 12.9277C7.20752 12.9277 7.64628 13.1253 7.96978 13.4769C8.29329 13.8285 8.47503 14.3055 8.47503 14.8027C8.47503 15.3 8.29329 15.7769 7.96978 16.1286C7.64628 16.4802 7.20752 16.6777 6.75003 16.6777C6.29253 16.6777 5.85377 16.4802 5.53027 16.1286C5.20677 15.7769 5.02503 15.3 5.02503 14.8027C5.02503 14.3055 5.20677 13.8285 5.53027 13.4769C5.85377 13.1253 6.29253 12.9277 6.75003 12.9277Z"
        fill="#161616"
      />
    </svg>
  );
};

export const PackageIcon = () => {
  return (
    <svg
      data-testid="package-icon"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.74414 0.200195C9.23281 0.0244141 9.76719 0.0244141 10.2594 0.200195L17.0094 2.61191C17.9023 2.93184 18.5 3.7791 18.5 4.73184V13.2678C18.5 14.217 17.9023 15.0678 17.0059 15.3877L10.2559 17.7994C9.76719 17.9752 9.23281 17.9752 8.74062 17.7994L1.99063 15.3877C1.09766 15.0678 0.5 14.2205 0.5 13.2678V4.73184C0.5 3.78262 1.09766 2.93184 1.99414 2.61191L8.74414 0.200195ZM9.5 2.32012L3.39336 4.4998L9.5 6.67949L15.6066 4.4998L9.5 2.32012ZM10.625 15.2787L16.25 13.2713V6.66191L10.625 8.66934V15.2787Z"
        fill="#161616"
      />
    </svg>
  );
};

export const PickUpIcon = ({isActive}: {isActive?: boolean}) => {
  return (
    <svg
      style={{paddingBottom: "2px"}}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="20"
        height="20"
        rx="10"
        stroke={isActive ? "white" : "black"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="5 5"
      />
      <path
        d="M11.0842 12.355H8.30835V10.8975H11.0842C11.5676 10.8975 11.9583 10.8193 12.2561 10.6631C12.554 10.5068 12.7712 10.292 12.908 10.0186C13.0496 9.74023 13.1204 9.42285 13.1204 9.06641C13.1204 8.72949 13.0496 8.41455 12.908 8.12158C12.7712 7.82373 12.554 7.58447 12.2561 7.40381C11.9583 7.22314 11.5676 7.13281 11.0842 7.13281H8.87231V16.332H7.03394V5.66797H11.0842C11.9094 5.66797 12.6101 5.81445 13.1863 6.10742C13.7673 6.39551 14.2092 6.7959 14.512 7.30859C14.8147 7.81641 14.9661 8.39746 14.9661 9.05176C14.9661 9.74023 14.8147 10.3311 14.512 10.8242C14.2092 11.3174 13.7673 11.6958 13.1863 11.9595C12.6101 12.2231 11.9094 12.355 11.0842 12.355Z"
        fill="black"
      />
    </svg>
  );
};
export const DeliveryIcon = ({isActive}: {isActive?: boolean}) => {
  return (
    <svg
      style={{paddingBottom: "2px"}}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="20"
        height="20"
        rx="10"
        stroke={isActive ? "white" : "black"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="5 5"
      />
      <path
        d="M10.1211 16.332H7.84326L7.85791 14.8745H10.1211C10.7803 14.8745 11.332 14.7305 11.7764 14.4424C12.2256 14.1543 12.5625 13.7417 12.7871 13.2046C13.0166 12.6675 13.1313 12.0278 13.1313 11.2856V10.707C13.1313 10.1309 13.0654 9.6206 12.9336 9.17627C12.8066 8.73193 12.6162 8.3584 12.3623 8.05566C12.1133 7.75293 11.8057 7.52344 11.4395 7.36719C11.0781 7.21094 10.6606 7.13281 10.187 7.13281H7.79932V5.66797H10.187C10.895 5.66797 11.542 5.7876 12.1279 6.02686C12.7139 6.26123 13.2192 6.60059 13.644 7.04492C14.0737 7.48926 14.4033 8.02148 14.6328 8.6416C14.8623 9.26172 14.977 9.95508 14.977 10.7217V11.2856C14.977 12.0522 14.8623 12.7456 14.6328 13.3657C14.4033 13.9858 14.0737 14.5181 13.644 14.9624C13.2144 15.4019 12.7017 15.7412 12.106 15.9805C11.5151 16.2148 10.8535 16.332 10.1211 16.332ZM8.86133 5.66797V16.332H7.02295V5.66797H8.86133Z"
        fill="black"
      />
    </svg>
  );
};

export const DriverIcon = () => {
  return (
    <svg
      data-testid="driver-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
    >
      <path
        d="M4.33906 0.882324C4.9358 0.882324 5.5081 1.14727 5.93005 1.61886C6.35201 2.09046 6.58906 2.73009 6.58906 3.39703C6.58906 4.06397 6.35201 4.7036 5.93005 5.1752C5.5081 5.64679 4.9358 5.91174 4.33906 5.91174C3.74233 5.91174 3.17003 5.64679 2.74807 5.1752C2.32612 4.7036 2.08906 4.06397 2.08906 3.39703C2.08906 2.73009 2.32612 2.09046 2.74807 1.61886C3.17003 1.14727 3.74233 0.882324 4.33906 0.882324ZM14.6891 0.882324C15.2858 0.882324 15.8581 1.14727 16.2801 1.61886C16.702 2.09046 16.9391 2.73009 16.9391 3.39703C16.9391 4.06397 16.702 4.7036 16.2801 5.1752C15.8581 5.64679 15.2858 5.91174 14.6891 5.91174C14.0923 5.91174 13.52 5.64679 13.0981 5.1752C12.6761 4.7036 12.4391 4.06397 12.4391 3.39703C12.4391 2.73009 12.6761 2.09046 13.0981 1.61886C13.52 1.14727 14.0923 0.882324 14.6891 0.882324ZM0.289062 10.2716C0.289062 8.42016 1.63344 6.91762 3.29 6.91762H4.49094C4.93812 6.91762 5.36281 7.02764 5.74531 7.22253C5.70875 7.44885 5.69187 7.6846 5.69187 7.9235C5.69187 9.12427 6.16437 10.2025 6.90969 10.9411C6.90406 10.9411 6.89844 10.9411 6.89 10.9411H0.888125C0.559062 10.9411 0.289062 10.6394 0.289062 10.2716ZM11.6881 10.9411C11.6825 10.9411 11.6769 10.9411 11.6684 10.9411C12.4166 10.2025 12.8862 9.12427 12.8862 7.9235C12.8862 7.6846 12.8666 7.45199 12.8328 7.22253C13.2153 7.02449 13.64 6.91762 14.0872 6.91762H15.2881C16.9447 6.91762 18.2891 8.42016 18.2891 10.2716C18.2891 10.6425 18.0191 10.9411 17.69 10.9411H11.6881ZM6.58906 7.9235C6.58906 7.12317 6.87353 6.35562 7.37987 5.7897C7.88622 5.22378 8.57298 4.90585 9.28906 4.90585C10.0051 4.90585 10.6919 5.22378 11.1983 5.7897C11.7046 6.35562 11.9891 7.12317 11.9891 7.9235C11.9891 8.72383 11.7046 9.49138 11.1983 10.0573C10.6919 10.6232 10.0051 10.9411 9.28906 10.9411C8.57298 10.9411 7.88622 10.6232 7.37987 10.0573C6.87353 9.49138 6.58906 8.72383 6.58906 7.9235ZM3.88906 16.1372C3.88906 13.8236 5.56812 11.947 7.63812 11.947H10.94C13.01 11.947 14.6891 13.8236 14.6891 16.1372C14.6891 16.5992 14.3544 16.9764 13.9381 16.9764H4.64C4.22656 16.9764 3.88906 16.6024 3.88906 16.1372Z"
        fill="#161616"
      />
    </svg>
  );
};

export const CompletedStopIcon = () => {
  return (
    <svg
      data-testid="completed-stop-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
    >
      <path
        d="M17.2985 18.9999C19.6846 18.9999 21.6185 17.066 21.6185 14.6799C21.6185 12.2937 19.6846 10.3599 17.2985 10.3599C14.9124 10.3599 12.9785 12.2937 12.9785 14.6799C12.9785 17.066 14.9124 18.9999 17.2985 18.9999ZM19.2054 13.8867L17.0454 16.0467C16.8868 16.2054 16.6303 16.2054 16.4733 16.0467L15.3933 14.9667C15.2347 14.8081 15.2347 14.5516 15.3933 14.3947C15.552 14.2377 15.8085 14.2361 15.9654 14.3947L16.7585 15.1878L18.6316 13.313C18.7903 13.1544 19.0468 13.1544 19.2037 13.313C19.3606 13.4716 19.3623 13.7281 19.2037 13.8851L19.2054 13.8867Z"
        fill="#161616"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3379 15.5799C11.6788 16.5036 11.0599 17.3089 10.5992 17.8917C10.1875 18.4094 9.42426 18.4094 9.01253 17.8917C7.29533 15.7193 3.37891 10.4542 3.37891 7.49681C3.37891 3.91003 6.25765 1 9.80586 1C13.3541 1 16.2328 3.91003 16.2328 7.49681C16.2328 8.19697 16.0133 9.02648 15.6554 9.91368C13.6783 10.5948 12.2578 12.4715 12.2578 14.68C12.2578 14.9872 12.2853 15.2879 12.3379 15.5799ZM11.3207 5.9655C10.9189 5.55937 10.374 5.33121 9.80586 5.33121C9.23768 5.33121 8.69278 5.55937 8.29101 5.9655C7.88925 6.37163 7.66354 6.92246 7.66354 7.49681C7.66354 8.07117 7.88925 8.622 8.29101 9.02813C8.69278 9.43426 9.23768 9.66242 9.80586 9.66242C10.374 9.66242 10.9189 9.43426 11.3207 9.02813C11.7225 8.622 11.9482 8.07117 11.9482 7.49681C11.9482 6.92246 11.7225 6.37163 11.3207 5.9655Z"
        fill="#161616"
      />
    </svg>
  );
};

export const RoadIcon = () => {
  return (
    <svg
      data-testid="road-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
    >
      <path
        d="M19.7562 14.5834L15.9136 4.58344C15.777 4.22781 15.4793 4 15.1516 4H12.469L12.5364 4.72375C12.5501 4.87125 12.4481 5 12.3176 5H11.516C11.3854 5 11.2835 4.87125 11.2972 4.72375L11.3645 4H8.68195C8.35402 4 8.05632 4.22781 7.9197 4.58344L4.07709 14.5834C3.82282 15.2456 4.22855 16 4.83962 16H10.2504L10.5338 12.9475C10.5575 12.6931 10.7461 12.5 10.9712 12.5H12.8624C13.0875 12.5 13.2761 12.6931 13.2997 12.9475L13.5831 16H18.994C19.605 16 20.0108 15.2456 19.7562 14.5834ZM11.1581 6.22375C11.1638 6.16231 11.1893 6.10545 11.2297 6.06413C11.2701 6.02281 11.3226 5.99997 11.3769 6H12.4569C12.5694 6 12.6639 6.09656 12.6757 6.22375L12.8022 7.58562C12.8228 7.80719 12.67 8 12.4743 8H11.3599C11.1639 8 11.0113 7.80719 11.0319 7.58562L11.1581 6.22375ZM12.6766 11.5H11.1567C10.8956 11.5 10.6919 11.2428 10.7194 10.9475L10.8588 9.4475C10.8824 9.19312 11.071 9 11.2961 9H12.5372C12.7623 9 12.9509 9.19312 12.9745 9.4475L13.1139 10.9475C13.1414 11.2428 12.9377 11.5 12.6766 11.5Z"
        fill="#161616"
      />
    </svg>
  );
};

export const StopDetailIcon = () => {
  return (
    <svg
      data-testid="stop-details-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5803 5.23244C4.5803 5.91085 5.13994 6.45968 5.83171 6.45968C6.16361 6.45968 6.48191 6.33038 6.71659 6.10023C6.95128 5.87008 7.08312 5.55792 7.08312 5.23244C7.08312 4.55402 6.52348 4.00519 5.83171 4.00519C5.49982 4.00519 5.18152 4.13449 4.94683 4.36464C4.71215 4.5948 4.5803 4.90695 4.5803 5.23244ZM2.33398 5.23244C2.33398 3.32678 3.88853 1.80225 5.83171 1.80225C7.77489 1.80225 9.32944 3.32678 9.32944 5.23244C9.32944 7.80127 5.83171 11.605 5.83171 11.605C5.83171 11.605 2.33398 7.80127 2.33398 5.23244ZM13.4968 6.10023C13.7315 6.33038 14.0498 6.45968 14.3817 6.45968C14.7136 6.45968 15.0319 6.33038 15.2666 6.10023C15.5013 5.87008 15.6331 5.55792 15.6331 5.23244C15.6331 5.07127 15.6008 4.91169 15.5379 4.76279C15.475 4.61389 15.3828 4.4786 15.2666 4.36464C15.1504 4.25068 15.0124 4.16028 14.8606 4.09861C14.7088 4.03693 14.546 4.00519 14.3817 4.00519C14.2174 4.00519 14.0546 4.03693 13.9028 4.09861C13.751 4.16028 13.613 4.25068 13.4968 4.36464C13.3806 4.4786 13.2884 4.61389 13.2256 4.76279C13.1627 4.91169 13.1303 5.07127 13.1303 5.23244C13.1303 5.55792 13.2621 5.87008 13.4968 6.10023ZM10.884 5.23244C10.884 3.32678 12.4385 1.80225 14.3817 1.80225C16.3249 1.80225 17.8794 3.32678 17.8794 5.23244C17.8794 6.88852 16.4257 9.05783 15.3927 10.3903C14.9461 10.6665 14.5459 11.0105 14.2064 11.4079C13.4979 10.5966 10.884 7.45311 10.884 5.23244ZM13.4117 12.6816C12.8513 12.934 12.4029 13.4013 12.1898 13.9985H8.02362C7.81766 13.428 7.38949 12.9608 6.83294 12.6993C6.27639 12.4379 5.63684 12.4034 5.05444 12.6035C4.76497 12.703 4.49833 12.8575 4.26976 13.058C4.04119 13.2586 3.85518 13.5014 3.72235 13.7726C3.58953 14.0437 3.5125 14.3379 3.49567 14.6382C3.47884 14.9386 3.52253 15.2392 3.62426 15.523C3.83301 16.095 4.26406 16.5628 4.82329 16.8241C5.38252 17.0855 6.02448 17.1192 6.60898 16.918C7.26967 16.6893 7.77489 16.1709 8.02362 15.523H12.1976C12.4259 16.158 12.9134 16.6321 13.5006 16.8723C13.1798 16.2094 13 15.4657 13 14.6799C13 13.9699 13.1468 13.2943 13.4117 12.6816Z"
        fill="#161616"
      />
      <path
        d="M18.5 19C19.6935 19 20.8381 18.5259 21.682 17.682C22.5259 16.8381 23 15.6935 23 14.5C23 13.3065 22.5259 12.1619 21.682 11.318C20.8381 10.4741 19.6935 10 18.5 10C17.3065 10 16.1619 10.4741 15.318 11.318C14.4741 12.1619 14 13.3065 14 14.5C14 15.6935 14.4741 16.8381 15.318 17.682C16.1619 18.5259 17.3065 19 18.5 19ZM17.7969 15.9062H18.2188V14.7812H17.7969C17.5631 14.7812 17.375 14.5932 17.375 14.3594C17.375 14.1256 17.5631 13.9375 17.7969 13.9375H18.6406C18.8744 13.9375 19.0625 14.1256 19.0625 14.3594V15.9062H19.2031C19.4369 15.9062 19.625 16.0943 19.625 16.3281C19.625 16.5619 19.4369 16.75 19.2031 16.75H17.7969C17.5631 16.75 17.375 16.5619 17.375 16.3281C17.375 16.0943 17.5631 15.9062 17.7969 15.9062ZM18.5 12.25C18.6492 12.25 18.7923 12.3093 18.8977 12.4148C19.0032 12.5202 19.0625 12.6633 19.0625 12.8125C19.0625 12.9617 19.0032 13.1048 18.8977 13.2102C18.7923 13.3157 18.6492 13.375 18.5 13.375C18.3508 13.375 18.2077 13.3157 18.1023 13.2102C17.9968 13.1048 17.9375 12.9617 17.9375 12.8125C17.9375 12.6633 17.9968 12.5202 18.1023 12.4148C18.2077 12.3093 18.3508 12.25 18.5 12.25Z"
        fill="#161616"
      />
    </svg>
  );
};

export const TrafficLightIcon = () => {
  return (
    <svg
      data-testid="traffic-light-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
    >
      <path
        d="M18.4872 7.75H16.474V6.41828C17.6441 5.95352 18.4872 4.71742 18.4872 3.25H16.474V2.125C16.474 1.50379 16.0232 1 15.4674 1H9.42794C8.87212 1 8.42136 1.50379 8.42136 2.125V3.25H6.4082C6.4082 4.71742 7.25121 5.95352 8.42136 6.41828V7.75H6.4082C6.4082 9.21742 7.25121 10.4535 8.42136 10.9183V12.25H6.4082C6.4082 13.7561 7.29682 15.0164 8.51541 15.451C8.90641 17.4784 10.5163 19 12.4477 19C14.379 19 15.9889 17.4784 16.3799 15.451C17.5985 15.0164 18.4872 13.7561 18.4872 12.25H16.474V10.9183C17.6441 10.4535 18.4872 9.21742 18.4872 7.75ZM12.4477 15.625C11.6138 15.625 10.9378 14.8695 10.9378 13.9375C10.9378 13.0055 11.6138 12.25 12.4477 12.25C13.2816 12.25 13.9575 13.0055 13.9575 13.9375C13.9575 14.8695 13.2816 15.625 12.4477 15.625ZM12.4477 11.125C11.6138 11.125 10.9378 10.3695 10.9378 9.4375C10.9378 8.50551 11.6138 7.75 12.4477 7.75C13.2816 7.75 13.9575 8.50551 13.9575 9.4375C13.9575 10.3695 13.2816 11.125 12.4477 11.125ZM12.4477 6.625C11.6138 6.625 10.9378 5.86949 10.9378 4.9375C10.9378 4.00551 11.6138 3.25 12.4477 3.25C13.2816 3.25 13.9575 4.00551 13.9575 4.9375C13.9575 5.86949 13.2816 6.625 12.4477 6.625Z"
        fill="#161616"
      />
    </svg>
  );
};

export const SatelliteIcon = () => {
  return (
    <svg
      data-testid="satellite-icon"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.15283 1.19678C8.8156 0.865396 8.2703 0.865396 7.93666 1.19678L4.49265 4.58116C4.15543 4.91254 4.15543 5.4484 4.49265 5.77626L7.69989 8.92796L7.14382 9.4744C6.25771 9.0725 5.27473 8.84688 4.23794 8.84688C3.1007 8.84688 2.03162 9.11833 1.0881 9.59426C0.765229 9.75996 0.718591 10.183 0.976892 10.4333L4.83705 14.2302L4.2487 14.8083C4.15543 14.7836 4.05498 14.7695 3.95094 14.7695C3.31595 14.7695 2.80294 15.2737 2.80294 15.8977C2.80294 16.5217 3.31595 17.0258 3.95094 17.0258C4.58593 17.0258 5.09894 16.5217 5.09894 15.8977C5.09894 15.7954 5.08459 15.7002 5.05948 15.6051L5.64783 15.0269L9.50799 18.8202C9.76629 19.074 10.1968 19.0282 10.3618 18.7109C10.8497 17.7837 11.126 16.7332 11.126 15.6156C11.126 14.5968 10.8964 13.6308 10.4874 12.7636L11.0434 12.2172L14.2471 15.3689C14.5843 15.7002 15.1296 15.7002 15.4633 15.3689L18.9073 11.9845C19.2445 11.6531 19.2445 11.1172 18.9073 10.7894L15.7 7.63767L17.6732 5.69871C18.1216 5.25803 18.1216 4.54238 17.6732 4.1017L15.9512 2.40952C15.5027 1.96884 14.7745 1.96884 14.326 2.40952L12.3529 4.34848L9.15283 1.19678ZM14.857 13.5709L12.2596 11.0185L14.4875 8.82925L17.0848 11.3852L14.857 13.5744V13.5709ZM8.91247 7.73286L6.31511 5.18047L8.54295 2.99121L11.1403 5.54359L8.91247 7.73286Z"
        fill="#161616"
      />
    </svg>
  );
};

export const ZoomAllIcon = () => {
  return (
    <svg
      data-testid="zoom-all-icon"
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.69231 1.6875H4.79487C5.26378 1.6875 5.64103 1.31133 5.64103 0.84375C5.64103 0.376172 5.26378 0 4.79487 0H1.12821C0.504167 0 0 0.502734 0 1.125V4.78125C0 5.24883 0.377244 5.625 0.846154 5.625C1.31506 5.625 1.69231 5.24883 1.69231 4.78125V1.6875ZM17.7692 1.6875H20.8718V4.78125C20.8718 5.24883 21.249 5.625 21.7179 5.625C22.1869 5.625 22.5641 5.24883 22.5641 4.78125V1.125C22.5641 0.502734 22.0599 0 21.4359 0H17.7692C17.3003 0 16.9231 0.376172 16.9231 0.84375C16.9231 1.31133 17.3003 1.6875 17.7692 1.6875ZM1.69231 16.3125V13.2188C1.69231 12.7512 1.31506 12.375 0.846154 12.375C0.377244 12.375 0 12.7512 0 13.2188V16.875C0 17.4973 0.504167 18 1.12821 18H4.79487C5.26378 18 5.64103 17.6238 5.64103 17.1562C5.64103 16.6887 5.26378 16.3125 4.79487 16.3125H1.69231ZM17.7692 16.3125C17.3003 16.3125 16.9231 16.6887 16.9231 17.1562C16.9231 17.6238 17.3003 18 17.7692 18H21.4359C22.0599 18 22.5641 17.4973 22.5641 16.875V13.2188C22.5641 12.7512 22.1869 12.375 21.7179 12.375C21.249 12.375 20.8718 12.7512 20.8718 13.2188V16.3125H17.7692Z"
        fill="#161616"
      />
    </svg>
  );
};

export const ZoomDriversIcon = () => {
  return (
    <svg
      data-testid="zoom-drivers-icon"
      width="23"
      height="18"
      viewBox="0 0 23 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.69231 1.65H4.79487C5.26378 1.65 5.64103 1.28219 5.64103 0.825C5.64103 0.367813 5.26378 0 4.79487 0H1.12821C0.504167 0 0 0.491562 0 1.1V4.675C0 5.13219 0.377244 5.5 0.846154 5.5C1.31506 5.5 1.69231 5.13219 1.69231 4.675V1.65ZM6.19808 7.7C6.42031 7.7 6.64037 7.65732 6.84569 7.5744C7.05101 7.49148 7.23757 7.36994 7.39472 7.21673C7.55186 7.06351 7.67652 6.88162 7.76157 6.68143C7.84661 6.48124 7.89038 6.26668 7.89038 6.05C7.89038 5.83332 7.84661 5.61876 7.76157 5.41857C7.67652 5.21839 7.55186 5.03649 7.39472 4.88327C7.23757 4.73006 7.05101 4.60852 6.84569 4.5256C6.64037 4.44268 6.42031 4.4 6.19808 4.4C5.97584 4.4 5.75578 4.44268 5.55046 4.5256C5.34514 4.60852 5.15858 4.73006 5.00143 4.88327C4.84429 5.03649 4.71963 5.21839 4.63459 5.41857C4.54954 5.61876 4.50577 5.83332 4.50577 6.05C4.50577 6.26668 4.54954 6.48124 4.63459 6.68143C4.71963 6.88162 4.84429 7.06351 5.00143 7.21673C5.15858 7.36994 5.34514 7.49148 5.55046 7.5744C5.75578 7.65732 5.97584 7.7 6.19808 7.7ZM5.26378 8.8C4.22724 8.8 3.38462 9.62156 3.38462 10.6322C3.38462 11.1375 3.80417 11.55 4.32596 11.55H6.30385C6.5859 10.3778 7.46026 9.42906 8.60256 9.02C8.33814 8.87906 8.03141 8.8 7.71058 8.8H5.26378ZM18.2381 11.55C18.7564 11.55 19.1795 11.1409 19.1795 10.6322C19.1795 9.61812 18.3369 8.8 17.3003 8.8H14.8535C14.5292 8.8 14.226 8.87906 13.9615 9.02C15.1038 9.42906 15.9782 10.3778 16.2603 11.55H18.2381ZM15.0862 11.55C14.783 10.7147 14.0321 10.0856 13.1154 9.93437C12.9779 9.91031 12.8369 9.9 12.6923 9.9H9.87179C9.72724 9.9 9.58622 9.91031 9.44872 9.93437C8.53205 10.0856 7.78109 10.7147 7.47788 11.55C7.38269 11.8078 7.33333 12.0863 7.33333 12.375C7.33333 12.8322 7.71058 13.2 8.17949 13.2H14.3846C14.8535 13.2 15.2308 12.8322 15.2308 12.375C15.2308 12.0863 15.1814 11.8078 15.0862 11.55ZM16.359 7.7C16.5812 7.7 16.8013 7.65732 17.0066 7.5744C17.2119 7.49148 17.3985 7.36994 17.5556 7.21673C17.7128 7.06351 17.8374 6.88162 17.9225 6.68143C18.0075 6.48124 18.0513 6.26668 18.0513 6.05C18.0513 5.83332 18.0075 5.61876 17.9225 5.41857C17.8374 5.21839 17.7128 5.03649 17.5556 4.88327C17.3985 4.73006 17.2119 4.60852 17.0066 4.5256C16.8013 4.44268 16.5812 4.4 16.359 4.4C16.1367 4.4 15.9167 4.44268 15.7114 4.5256C15.506 4.60852 15.3195 4.73006 15.1623 4.88327C15.0052 5.03649 14.8805 5.21839 14.7955 5.41857C14.7104 5.61876 14.6667 5.83332 14.6667 6.05C14.6667 6.26668 14.7104 6.48124 14.7955 6.68143C14.8805 6.88162 15.0052 7.06351 15.1623 7.21673C15.3195 7.36994 15.506 7.49148 15.7114 7.5744C15.9167 7.65732 16.1367 7.7 16.359 7.7ZM13.5385 6.6C13.5385 6.01652 13.3007 5.45694 12.8776 5.04436C12.4544 4.63178 11.8805 4.4 11.2821 4.4C10.6836 4.4 10.1097 4.63178 9.68653 5.04436C9.26337 5.45694 9.02564 6.01652 9.02564 6.6C9.02564 7.18348 9.26337 7.74306 9.68653 8.15563C10.1097 8.56822 10.6836 8.8 11.2821 8.8C11.8805 8.8 12.4544 8.56822 12.8776 8.15563C13.3007 7.74306 13.5385 7.18348 13.5385 6.6ZM17.7692 1.65H20.8718V4.675C20.8718 5.13219 21.249 5.5 21.7179 5.5C22.1869 5.5 22.5641 5.13219 22.5641 4.675V1.1C22.5641 0.491562 22.0599 0 21.4359 0H17.7692C17.3003 0 16.9231 0.367813 16.9231 0.825C16.9231 1.28219 17.3003 1.65 17.7692 1.65ZM1.69231 15.95V12.925C1.69231 12.4678 1.31506 12.1 0.846154 12.1C0.377244 12.1 0 12.4678 0 12.925V16.5C0 17.1084 0.504167 17.6 1.12821 17.6H4.79487C5.26378 17.6 5.64103 17.2322 5.64103 16.775C5.64103 16.3178 5.26378 15.95 4.79487 15.95H1.69231ZM17.7692 15.95C17.3003 15.95 16.9231 16.3178 16.9231 16.775C16.9231 17.2322 17.3003 17.6 17.7692 17.6H21.4359C22.0599 17.6 22.5641 17.1084 22.5641 16.5V12.925C22.5641 12.4678 22.1869 12.1 21.7179 12.1C21.249 12.1 20.8718 12.4678 20.8718 12.925V15.95H17.7692Z"
        fill="#161616"
      />
    </svg>
  );
};

export const ZoomJobsIcon = () => {
  return (
    <svg
      data-testid="zoom-job-icon"
      width="23"
      height="19"
      viewBox="0 0 23 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="22.5641" height="18" transform="translate(0 0.600098)" fill="@161616" />
      <path
        d="M1.69231 2.2876H4.79487C5.26378 2.2876 5.64103 1.91143 5.64103 1.44385C5.64103 0.97627 5.26378 0.600098 4.79487 0.600098H1.12821C0.504167 0.600098 0 1.10283 0 1.7251V5.38135C0 5.84893 0.377244 6.2251 0.846154 6.2251C1.31506 6.2251 1.69231 5.84893 1.69231 5.38135V2.2876ZM17.7692 2.2876H20.8718V5.38135C20.8718 5.84893 21.249 6.2251 21.7179 6.2251C22.1869 6.2251 22.5641 5.84893 22.5641 5.38135V1.7251C22.5641 1.10283 22.0599 0.600098 21.4359 0.600098H17.7692C17.3003 0.600098 16.9231 0.97627 16.9231 1.44385C16.9231 1.91143 17.3003 2.2876 17.7692 2.2876ZM1.69231 16.9126V13.8188C1.69231 13.3513 1.31506 12.9751 0.846154 12.9751C0.377244 12.9751 0 13.3513 0 13.8188V17.4751C0 18.0974 0.504167 18.6001 1.12821 18.6001H4.79487C5.26378 18.6001 5.64103 18.2239 5.64103 17.7563C5.64103 17.2888 5.26378 16.9126 4.79487 16.9126H1.69231ZM17.7692 16.9126C17.3003 16.9126 16.9231 17.2888 16.9231 17.7563C16.9231 18.2239 17.3003 18.6001 17.7692 18.6001H21.4359C22.0599 18.6001 22.5641 18.0974 22.5641 17.4751V13.8188C22.5641 13.3513 22.1869 12.9751 21.7179 12.9751C21.249 12.9751 20.8718 13.3513 20.8718 13.8188V16.9126H17.7692Z"
        fill="#161616"
      />
      <path
        d="M10.8084 4.10046C11.1147 3.9906 11.4496 3.9906 11.7581 4.10046L15.9889 5.60779C16.5486 5.80774 16.9232 6.33728 16.9232 6.93274V12.2677C16.9232 12.861 16.5486 13.3927 15.9867 13.5926L11.7559 15.1C11.4496 15.2098 11.1147 15.2098 10.8062 15.1L6.57541 13.5926C6.01571 13.3927 5.64111 12.8632 5.64111 12.2677V6.93274C5.64111 6.33948 6.01571 5.80774 6.57761 5.60779L10.8084 4.10046ZM11.2821 5.42541L7.45461 6.78772L11.2821 8.15002L15.1097 6.78772L11.2821 5.42541ZM11.9873 13.5245L15.5129 12.2699V8.13904L11.9873 9.39368V13.5245Z"
        fill="#161616"
      />
    </svg>
  );
};

export const ZoomInIcon = () => {
  return (
    <svg
      data-testid="zoom-in-icon"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9489 7.125H11.1797V1.5C11.1797 0.809766 10.6055 0.25 9.89761 0.25H8.61556C7.90763 0.25 7.33351 0.809766 7.33351 1.5V7.125H1.56428C0.856345 7.125 0.282227 7.68477 0.282227 8.375V9.625C0.282227 10.3152 0.856345 10.875 1.56428 10.875H7.33351V16.5C7.33351 17.1902 7.90763 17.75 8.61556 17.75H9.89761C10.6055 17.75 11.1797 17.1902 11.1797 16.5V10.875H16.9489C17.6568 10.875 18.2309 10.3152 18.2309 9.625V8.375C18.2309 7.68477 17.6568 7.125 16.9489 7.125Z"
        fill="#161616"
      />
    </svg>
  );
};

export const ZoomOutIcon = () => {
  return (
    <svg
      data-testid="zoom-out-icon"
      width="19"
      height="4"
      viewBox="0 0 19 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9489 0.125H1.56428C0.856345 0.125 0.282227 0.684766 0.282227 1.375V2.625C0.282227 3.31523 0.856345 3.875 1.56428 3.875H16.9489C17.6568 3.875 18.2309 3.31523 18.2309 2.625V1.375C18.2309 0.684766 17.6568 0.125 16.9489 0.125Z"
        fill="#161616"
      />
    </svg>
  );
};

export const MinimalStopIcon = ({color = "797979"}: {color?: string}) => {
  return (
    <svg
      data-testid="minimal-stop-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g filter="url(#filter0_d_3090_158066)">
        <circle data-testid={"minimal-circle"} cx="9" cy="9" r="5" fill={color} />
        <circle cx="9" cy="9" r="5.5" stroke="white" />
      </g>
      <defs>
        <filter
          id="filter0_d_3090_158066"
          x="0"
          y="0"
          width="18"
          height="18"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3090_158066" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3090_158066" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const MapPopOutIcon = () => {
  return (
    <svg
      data-testid="map-pop-out-icon"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.40002 2.39999C6.84774 2.39999 6.40002 2.84771 6.40002 3.39999V12.6C6.40002 13.1523 6.84774 13.6 7.40002 13.6H16.6C17.1523 13.6 17.6 13.1523 17.6 12.6V11.7714C17.6 11.2191 18.0477 10.7714 18.6 10.7714C19.1523 10.7714 19.6 11.2191 19.6 11.7714V12.6C19.6 14.2569 18.2569 15.6 16.6 15.6H15.5854C15.595 15.6557 15.6 15.713 15.6 15.7714V16.6C15.6 18.2568 14.2569 19.6 12.6 19.6H3.40002C1.74317 19.6 0.400024 18.2568 0.400024 16.6V7.39999C0.400024 5.74313 1.74317 4.39999 3.40002 4.39999H4.2286C4.28705 4.39999 4.34432 4.405 4.40002 4.41462V3.39999C4.40002 1.74314 5.74317 0.399994 7.40002 0.399994H8.2286C8.78088 0.399994 9.2286 0.847709 9.2286 1.39999C9.2286 1.95228 8.78088 2.39999 8.2286 2.39999H7.40002ZM4.40002 6.38535C4.34432 6.39497 4.28705 6.39999 4.2286 6.39999H3.40002C2.84774 6.39999 2.40002 6.8477 2.40002 7.39999V16.6C2.40002 17.1523 2.84774 17.6 3.40002 17.6H12.6C13.1523 17.6 13.6 17.1523 13.6 16.6V15.7714C13.6 15.713 13.605 15.6557 13.6147 15.6H7.40002C5.74317 15.6 4.40002 14.2568 4.40002 12.6V6.38535ZM11.5 1.5C11.5 0.947715 11.9477 0.5 12.5 0.5H18.5C19.0523 0.5 19.5 0.947715 19.5 1.5V7.5C19.5 8.05229 19.0523 8.5 18.5 8.5C17.9477 8.5 17.5 8.05229 17.5 7.5V3.91421L14.2071 7.20711L11.7071 9.70711C11.3166 10.0976 10.6834 10.0976 10.2929 9.70711C9.90237 9.31658 9.90237 8.68342 10.2929 8.29289L12.7929 5.79289L16.0858 2.5H12.5C11.9477 2.5 11.5 2.05228 11.5 1.5Z"
        fill="#111827"
      />
    </svg>
  );
};
